import {
  Box,
  IconButton,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';

import { GetDeliverablesDeliverableDataFragmentGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { StatusFAIcon } from './StatusContainer';
import { getComputedStatus } from './utils';
import { colors } from 'packages/common-frontend/colors';
import { Icon as FaIcon } from 'packages/common-frontend/components/icons/fontAwesome';

type Props = { deliverable: GetDeliverablesDeliverableDataFragmentGQLType };
export const DeliverableDependenciesPopover = ({ deliverable }: Props) => {
  const { dependencies } = deliverable;
  return (
    <Popover placement="auto-end" trigger="hover">
      <PopoverTrigger>
        <IconButton
          color={colors.blue[400]}
          aria-label="dependencies"
          icon={<FaIcon icon="circle-info" />}
          variant="unstyled"
        />
      </PopoverTrigger>
      <PopoverContent
        bg="millet.50"
        minW={{ base: '100%', lg: 'max-content' }}
        p="12px"
      >
        <PopoverHeader
          alignContent="flex-start"
          fontWeight="medium"
          textAlign="left"
          fontSize="16px"
        >
          Deliverable Dependencies
        </PopoverHeader>
        <PopoverBody>
          <VStack spacing="16px" align="start">
            {dependencies.map((dependency) => {
              const { deliverable: d } = dependency;
              return (
                <Box key={d.id}>
                  <StatusFAIcon
                    computedStatus={getComputedStatus(d.status, d.dueDate)}
                    size="large"
                  />
                  <Text display="inline" pl="16px">
                    {d.name}
                  </Text>
                </Box>
              );
            })}
          </VStack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
